$(document).ready(function() {
  
  /**************************************************************************/
  $('.pr-freshlook .pg_view_table_option button.pg_view_table_select').click(function(){
    $('.pr-freshlook .pg_content_view_table_content').toggleClass("select-value");
  });
  var val_pg_grad = "";var isDisabled = false;
  $('.pr-freshlook .pg_content_view_table_content .pg_content_view_table div span').click(function(){
    isDisabled = $(this).attr('disabled');
    if(!isDisabled){
      val_pg_grad = $(this).attr("data-id");
      $('.pg__option__values .select.select--option select.pg__option__value').val(val_pg_grad);
      $('form.product-form select.variant-id option:selected').removeAttr('selected');
      $('form.product-form select.variant-id option').each(function(){
          //console.log("option: "+$(this).text().trim());
        if($(this).text().trim() == val_pg_grad){
          $(this).attr("selected","selected");
        }
      });
      $('.pr-freshlook .pg_content_view_table_content').removeClass("select-value");
    }
  });
  
  $('.collec-pr-freshlook .pg_view_table_option button.pg_view_table_select').click(function(){
    var pr_sel_frsh = $(this).closest('.grid__item').attr('data-product-handle');
    $('*[data-product-handle="'+pr_sel_frsh+'"] .collec-pr-freshlook .pg_content_view_table_content').toggleClass("select-value");
  });
  var coll_val_pg_grad = "";var coll_isDisabled = false;
  $('.collec-pr-freshlook .pg_content_view_table_content .pg_content_view_table div span').click(function(){
    coll_isDisabled = $(this).attr('disabled');
    if(!coll_isDisabled){
      coll_val_pg_grad = $(this).attr("data-id");
      var pr_sel_frsh = $(this).closest('.grid__item').attr('data-product-handle');
      $('*[data-product-handle="'+pr_sel_frsh+'"] .collec-pr-freshlook select.pg__option__value').val(coll_val_pg_grad);
      
      $('*[data-product-handle="'+pr_sel_frsh+'"] form select.variant-id option:selected').removeAttr('selected');
      $('*[data-product-handle="'+pr_sel_frsh+'"] form select.variant-id option').each(function(){
          //console.log("option: "+$(this).text().trim());
        if($(this).text().trim() == coll_val_pg_grad){
          $(this).attr("selected","selected");
        }
      });
      $('*[data-product-handle="'+pr_sel_frsh+'"] .collec-pr-freshlook .pg_content_view_table_content').removeClass("select-value");
      
    }
  });
  
  /**************************************************************************/
    var heightTitle = 0;
  $('.grid--products.products.grid--not-empty.grid--large .grid__item').each(function(){
    $('a.item__name.pg__name--grid-mode', this).each(function(){
        console.log('actual -> '+$(this).height()+' | mayor '+heightTitle);
        if($(this).height() > heightTitle) {
          heightTitle = $(this).height(); 
        }
    });
    //$('a.item__name.pg__name--grid-mode',this).height(heightTitle);
  });
  $('.grid--products.products.grid--not-empty.grid--large .grid__item').each(function(){
    $('a.item__name.pg__name--grid-mode',this).height(heightTitle);
  });


  
  $('body.template-cart table.cart-page__items-table tr.options-group:not(.options-hidden) td.cart__remove-wrap a.cart__remove').click(function(){
    setTimeout(location.reload(true), 1200);
  });
  $('div#bt-sidebar-cart tr.options-group td.hc__item__remove-wrap a.hc__item__remove').click(function(){
    setTimeout(location.reload(true), 1200);
  });
  
  /************** ICON LOADING ***********************************************/
/*  var target = document.querySelector('.w3-product-options');
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation){
      console.log("asd "+mutation.type);
      $('button#btn-micas').attr('disabled' , false);
      $('button#btn-blupers').attr('disabled' , false);
      $("button#btn-micas").removeClass('disabled');
      $("button#btn-blupers").removeClass('disabled');
      $('.load-btn-micas').hide();
    });
  });
var config = { childList: true, subtree: true }
observer.observe(target, config);
  */

  /*
  $(".w3-product-options").on("DOMNodeInserted", ".form-micas-inicio", function(){
    $('button#btn-micas').attr('disabled' , false);
    $('button#btn-blupers').attr('disabled' , false);
    $("button#btn-micas").removeClass('disabled');
    $("button#btn-blupers").removeClass('disabled');
    $('.load-btn-micas').hide();
  });*/
 /*************************************************************/  

var dias=0;
var d = "";
var month ="";
var day ="";
var fecha_ENTREGA="";   
var meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
var mes="";
  
var pasos_actual = 0;
var pasos_graduacion = "";
var tipo_graduacion = "";
var tablagrd = "";
var tablagrd2 = "";
var cargar = 0;
var manual = 0;
var manual2 = 0;
var garantia= 0;
var lectura = 0;
  var res_mc = 0;
var tipo_pasos="270";
  
var montoarmazon = 0;  
var montopaso1 = 0;
var montopaso2 = 0; 
var montograduacion =0;
var totallente= 0;
var addhtml =0;
  
var mica_paso1="";
var mica_paso2="";
var mica_paso3="";
var texto_paso1="";
var texto_paso2="";
var texto_paso3="";
  tablagrd = $("div#w3-tabla-graduacion").html();
  tablagrd2 = $("div#w3-tabla-graduacion2").html();
  
  montoarmazon = $("span.product-price__price span.money").text();
  montoarmazon = montoarmazon.replace(/[$.]/g,'');
  montoarmazon = montoarmazon.replace(/,/g, '');
  
 // ------------------------------------------------------ 
  $("div#btn-vdv_micas button#btn-armazon").click(function(){ //Solo armazon
    $("div#w3-tabla-graduacion").html('');
    $("div#w3-tabla-graduacion2").html('');
    $("div#w3-btn-add-to-cart button.w3-options-add-to-cart").click();
  });
  $("div#btn-vdv_micas button#btn-blupers").click(function(){ // Lentes para computadora
    $("div#w3-tabla-graduacion").html('');
    $("div#w3-tabla-graduacion2").html('');
    $('.custom-blupers input[value="Lentes para computadora (sin graduación)"]').click();
    $("div#w3-btn-add-to-cart button.w3-options-add-to-cart").click();
  });
  $("div#btn-vdv_micas button#btn-micas-270").click(function(){ // Productos 270 -----------------
    tipo_pasos="270";
    $("div#btn-vdv_micas").hide();
      $("div#loading-micas").hide();
      $("div#w3-tab-graduacion").removeClass('hide').addClass('active');
      $('.form-micas-inicio-270 [name="properties[Tipo de mica]"]').val("Monofocal");
      $("div#w3-btn-add-to-cart").show();
  });
  $("div#btn-vdv_micas button#btn-micas").click(function(){ // Comprar con Graduación --------------------
    tipo_pasos="mica";
    $("div#btn-vdv_micas").hide();
      $("div#loading-micas").hide();
      $("div.w3-product-options").show();
    /////////////
      //$("div.form-micas-inicio").show();
        $("div.form-micas-fin").show();
      $(".line_vdv_micas .sel_vdv_micas").css("width", "33.3%");
      $('.mica-monofocal input[value="Monofocal"]').click();
        $("div#w3-btn-options-dir").addClass('str');
    
    $("div#w3-total-lente").removeClass('hide');
        montopaso1 = 0;
        totallente = parseInt(montoarmazon);
console.log("montoarmazon: "+montoarmazon+ " totallente: "+totallente);
        $("div#w3-total-lente").html('<div class="w3-custom"><div class="w3-select"><span class="w3-top-txt">Total</span></div><span class="w3-select-price">$ '+totallente+'</span></div>');
        $("div#w3-resumen-compra #w3-resumen-paso1").html('<div class="w3-custom"><div class="w3-select"><span class="w3-top-txt">Mica</span><span>Monofocal</span></div><span class="w3-select-price">Gratis</span></div>');
    /////////////
      $("div#w3-btn-add-to-cart").show();
      $("div#w3-resumen-compra").show();
      $("div#sel_micas").show();
      pasos_actual = 1;
      $('.form-micas-gar input[value="90 días"]').click();
      $("div#w3-resumen-compra #w3-resumen-armazon").html('<div class="w3-custom"><div class="w3-select"><span class="w3-top-txt">Armazón</span><span>'+$("h1.product-single__title").text()+'</span></div><span class="w3-select-price"> $ '+parseInt(montoarmazon)+'</span></div>');
      $("div#w3-tabla-graduacion").html('');
      $("div#w3-tabla-graduacion2").html('');
  });
  
  
//////////////////// PASO 1 GRADUACION ////////////////////////////////////////////////////////////////-----------------------
  var w3_opcion="";
  var w3_consulta=false;
  $(".w3-product-options").on("click touchend", ".form-micas-inicio .image-picker-item", function(){ //mostrar tipo micas
      if($(".form-micas-inicio .image-picker-item").hasClass("imagepicker-selected")){
        $("div.form-micas-inicio").hide();
        $("div.form-micas-fin").show();
        $("div#w3-btn-options-dir").addClass('str');
        $("div#w3-btn-options-dir div#w3-ret-options").addClass('mcs');
        $("div#w3-btn-options-dir div#w3-ret-options").show();
        pasos_actual = 2;
        //////////////////////////////////////
        w3_opcion = $(this).attr('data-name');
        mica_paso1 = $(this).attr('data-name');
/*        if(w3_opcion == "Monofocal"){
          dias = 5;
          $('div#w3-tabla-graduacion tr#row-adicion').hide();
        }
        else{
          dias = 7;
          $('div#w3-tabla-graduacion tr#row-adicion').show();
        }
          d = new Date();
          d.setDate(d.getDate() + dias);
          month = d.getMonth()+1;
          day = d.getDate();
          mes = meses[month - 1];
          fecha_ENTREGA =(day<10 ? '0' : '') + day+ ' ' + mes + ' ' +d.getFullYear();*/
         // $(".w3-product-delivery b#delivery-time").html('TIEMPO DE ENTREGA '+dias+' DÍAS HÁBILES, FECHA ESTIMADA: '+fecha_ENTREGA);
        ///////////////////////////////
        $(".line_vdv_micas .sel_vdv_micas").css("width", "33.3%");
        if(w3_opcion == "Flat top"){
          /*var blup = $(".form-micas-fin .imagepicker-items").children().eq(2);
          var polblup = $(".form-micas-fin .imagepicker-items").children().eq(4);
          $(blup).addClass('hide');
          $(polblup).addClass('hide');*/
        }
        else{
          $(".form-micas-fin .image-picker-item").removeClass('hide');
        }
        $("div#w3-total-lente").removeClass('hide');
        //montopaso1 = $(".form-micas-inicio .image-picker-item.imagepicker-selected span.precio-paso").text();
        montopaso1 = 0;
        totallente = parseInt(montoarmazon) + parseInt(montopaso1);
console.log("montopaso1: "+montopaso1+ " totallente: "+totallente);
        $("div#w3-total-lente").html('<div class="w3-custom"><div class="w3-select"><span class="w3-top-txt">Total</span></div><span class="w3-select-price">$ '+totallente+'</span></div>');
        
        texto_paso1 = "+$ "+parseInt(montopaso1);
        if(parseInt(montopaso1)== 0){
          texto_paso1="Gratis";
        }
        $("div#w3-resumen-compra #w3-resumen-paso1").html('<div class="w3-custom"><div class="w3-select"><span class="w3-top-txt">'+$('.form-micas-inicio .product-options-field-name').text()+'</span><span>'+mica_paso1+'</span></div><span class="w3-select-price">'+texto_paso1+'</span></div>');
      }
      else{
        $("div#w3-total-lente").addClass('hide');
        $("div#w3-btn-options-dir").removeClass('str');
        pasos_actual = 1;
        //$(".w3-product-delivery b#delivery-time").html('TIEMPO DE ENTREGA DE 5 A 7 DÍAS HÁBILES');
        $(".line_vdv_micas .sel_vdv_micas").css("width", "0%");
      }
      res_mc = 0;
      $(".form-micas-fin .image-picker-item").removeClass("imagepicker-selected");
      $("div#w3-tab-graduacion li").removeClass("imagepicker-selected");
      $("div#w3-btn-options-dir div#w3-adv-options").removeClass();
      $("div#w3-btn-options-dir div#w3-adv-options").hide();
      $("div#w3-btn-add-to-cart button.w3-options-add-to-cart").hide();
  });
  $("div#w3-btn-options-dir").on("click", "div#w3-adv-options.tpo p", function(){ //avanzar a tipo micas
    $("div.form-micas-inicio").hide();
    $("div.form-micas-fin").show();
    if($(".form-micas-fin .image-picker-item").hasClass("imagepicker-selected")){
      $("div#w3-btn-options-dir div#w3-adv-options").removeClass().addClass('mcs');
    }
    else{
      $("div#w3-btn-options-dir div#w3-adv-options").removeClass();
      $("div#w3-btn-options-dir div#w3-adv-options").hide();
    }
    $("div#w3-btn-options-dir div#w3-ret-options").addClass('mcs');
    $("div#w3-btn-options-dir div#w3-ret-options").show();
  });
//////////////////// PASO 2 MICAS ////////////////////////////////////////////////////////////////-----------------------
  $(".w3-product-options").on("click touchend", ".form-micas-fin .image-picker-item", function(){ //mostrar graduacion
    if($(".form-micas-fin .image-picker-item").hasClass("imagepicker-selected")){
      $("div.form-micas-fin").hide();
      $(".line_vdv_micas .sel_vdv_micas").css("width", "66.6%");
      $("div#w3-tab-graduacion").removeClass('hide').addClass('active');
      $("div#w3-btn-options-dir div#w3-ret-options").removeClass().addClass('grd');
      pasos_actual = 3;
      mica_paso2 = $(this).attr('data-name');
      
      montopaso2 = $(".form-micas-fin .image-picker-item.imagepicker-selected span.precio-paso").text();
      totallente = parseInt(montoarmazon) + parseInt(montopaso1)+ parseInt(montopaso2);
console.log("montopaso1: "+montopaso1+ " montopaso2: "+montopaso2+ " totallente: "+totallente);
      $("div#w3-total-lente").html('<div class="w3-custom"><div class="w3-select"><span class="w3-top-txt">Total</span></div><span class="w3-select-price">$ '+totallente+'</span></div>');
        
        texto_paso2 = "+$ "+parseInt(montopaso2);
        if(parseInt(montopaso2)== 0){
          texto_paso2="Gratis";
        }
        $("div#w3-resumen-compra #w3-resumen-paso2").html('<div class="w3-custom"><div class="w3-select"><span class="w3-top-txt">Material de las micas</span><span>'+mica_paso2+'</span></div><span class="w3-select-price">'+texto_paso2+'</span></div>');
    }
    else{
      totallente = parseInt(montoarmazon) + parseInt(montopaso1);
      $("div#w3-total-lente").html('<div class="w3-custom"><div class="w3-select"><span class="w3-top-txt">Total</span></div><span class="w3-select-price">$ '+totallente+'</span></div>');
      
      $(".line_vdv_micas .sel_vdv_micas").css("width", "33.3%");
    }
    res_mc = 0;
    $("div#w3-btn-options-dir div#w3-adv-options").removeClass();
    $("div#w3-btn-options-dir div#w3-adv-options").hide();
    $("div#w3-tab-graduacion li").removeClass("imagepicker-selected");
      $("div#w3-btn-add-to-cart button.w3-options-add-to-cart").hide();
  });
  $("div#w3-btn-options-dir").on("click", "div#w3-ret-options.mcs p", function(){ //regresar a tipo graduacion
    $("div.form-micas-fin").hide();
    $("div.form-micas-inicio").show();
    $("div#w3-btn-options-dir div#w3-ret-options").removeClass();
    $("div#w3-btn-options-dir div#w3-ret-options").hide();
    $("div#w3-btn-options-dir div#w3-adv-options").removeClass().addClass('tpo');
    $("div#w3-btn-options-dir div#w3-adv-options").show();
  });
  $("div#w3-btn-options-dir").on("click", "div#w3-adv-options.mcs p", function(){ //avanzar a graduacion
    $("div.form-micas-fin").hide();
    $("div#w3-tab-graduacion").removeClass('hide').addClass('active');
    $("div#w3-btn-options-dir div#w3-ret-options").removeClass().addClass('grd');
    if(pasos_actual == 3){
      $("div#w3-btn-options-dir div#w3-adv-options").removeClass();
      $("div#w3-btn-options-dir div#w3-adv-options").hide();
    }
    if($("div#w3-tab-graduacion li.gr-1").hasClass('imagepicker-selected')){
      $("div#w3-btn-options-dir div#w3-adv-options").removeClass().addClass('grd');
    }
    if($("div#w3-tab-graduacion li.gr-2").hasClass('imagepicker-selected')){
      $("div#w3-btn-options-dir div#w3-adv-options").removeClass().addClass('grd2');
    }
    if($("div#w3-tab-graduacion li.gr-3").hasClass('imagepicker-selected')){
      $("div#w3-btn-options-dir div#w3-adv-options").removeClass().addClass('grd3');
    }
    if($("div#w3-tab-graduacion li.gr-4").hasClass('imagepicker-selected')){
      $("div#w3-btn-options-dir div#w3-adv-options").removeClass().addClass('grd4');
    }
  });
  
//////////////////// GRADUACION BAJA Y ALTA /////////////////////////////////////////////////-----------------------
var grad_ed = 0; // esfera derecha
var grad_ei = 0; // esfera izquierda
var grad_cd = 0; // cilindro derecho
var grad_ci = 0; // cilindro izquierdo
//$("div#w3-tabla-graduacion table.datos-subir-manual select#EsferaOD").change(function(){
$("div#w3-tabla-graduacion").on('change', 'table.datos-subir-manual select#EsferaOD', function() {
  if($('.form-micas-grad input[value="Graduación alta"]').prop('checked', true)){
    $('.form-micas-grad input[value="Graduación alta"]').click();
  }
  if($('.form-micas-grad input[value="Graduación baja"]').prop('checked', true)){
    $('.form-micas-grad input[value="Graduación baja"]').click();
  }
  if(($('div#w3-tabla-graduacion table.datos-subir-manual select#EsferaOD option:selected').val() >= '-325' && $('div#w3-tabla-graduacion table.datos-subir-manual select#EsferaOD option:selected').val() <= '-825') || ($('div#w3-tabla-graduacion table.datos-subir-manual select#EsferaOD option:selected').val() >= '+325' && $('div#w3-tabla-graduacion table.datos-subir-manual select#EsferaOD option:selected').val() <= '+800')){
    grad_ed=1;
  }
  else{
    grad_ed=0;
  }
  if(grad_ed==1 || grad_ei==1 || grad_cd==1 || grad_ci==1){
    tipo_graduacion = "Graduación alta";
    $('.form-micas-grad input[value="Graduación alta"]').click();
    montograduacion = "300";
  }
  else{
    tipo_graduacion = "Graduación baja";
    $('.form-micas-grad input[value="Graduación baja"]').click();
    montograduacion = "0";
  }
  totallente = parseInt(montoarmazon) + parseInt(montopaso1) + parseInt(montopaso2) + parseInt(montograduacion);
  $("div#w3-total-lente").html('<div class="w3-custom"><div class="w3-select"><span class="w3-top-txt">Total</span></div><span class="w3-select-price">$ '+totallente+'</span></div>');
        
        texto_paso3 = "+$ "+parseInt(montograduacion);
        if(parseInt(montograduacion)== 0){
          texto_paso3="Gratis";
        }
        $("div#w3-resumen-compra #w3-resumen-paso3-2").html('<div class="w3-custom"><div class="w3-select"><span>'+tipo_graduacion+'</span></div><span class="w3-select-price">'+texto_paso3+'</span></div>');
        
});
$("div#w3-tabla-graduacion").on('change', 'table.datos-subir-manual select#EsferaOI', function() {
  if($('.form-micas-grad input[value="Graduación alta"]').prop('checked', true)){
    $('.form-micas-grad input[value="Graduación alta"]').click();
  }
  if($('.form-micas-grad input[value="Graduación baja"]').prop('checked', true)){
    $('.form-micas-grad input[value="Graduación baja"]').click();
  }
  if(($('div#w3-tabla-graduacion table.datos-subir-manual select#EsferaOI option:selected').val() >= '-325' && $('div#w3-tabla-graduacion table.datos-subir-manual select#EsferaOI option:selected').val() <= '-875') || ($('div#w3-tabla-graduacion table.datos-subir-manual select#EsferaOI option:selected').val() >= '+325' && $('div#w3-tabla-graduacion table.datos-subir-manual select#EsferaOI option:selected').val() <= '+800')){
    grad_ei=1;
  }
  else{
    grad_ei=0;
  }
  if(grad_ed==1 || grad_ei==1 || grad_cd==1 || grad_ci==1){
    tipo_graduacion = "Graduación alta";
    $('.form-micas-grad input[value="Graduación alta"]').click();
    montograduacion = "300";
  }
  else{
    tipo_graduacion = "Graduación baja";
    $('.form-micas-grad input[value="Graduación baja"]').click();
    montograduacion = "0";
  }
  totallente = parseInt(montoarmazon) + parseInt(montopaso1) + parseInt(montopaso2) + parseInt(montograduacion);
  $("div#w3-total-lente").html('<div class="w3-custom"><div class="w3-select"><span class="w3-top-txt">Total</span></div><span class="w3-select-price">$ '+totallente+'</span></div>');
        
        texto_paso3 = "+$ "+parseInt(montograduacion);
        if(parseInt(montograduacion)== 0){
          texto_paso3="Gratis";
        }
        $("div#w3-resumen-compra #w3-resumen-paso3-2").html('<div class="w3-custom"><div class="w3-select"><span>'+tipo_graduacion+'</span></div><span class="w3-select-price">'+texto_paso3+'</span></div>');
});
$("div#w3-tabla-graduacion").on('change', 'table.datos-subir-manual select#CilindroOD', function() {
  if($('.form-micas-grad input[value="Graduación alta"]').prop('checked', true)){
    $('.form-micas-grad input[value="Graduación alta"]').click();
  }
  if($('.form-micas-grad input[value="Graduación baja"]').prop('checked', true)){
    $('.form-micas-grad input[value="Graduación baja"]').click();
  }
  if($('div#w3-tabla-graduacion table.datos-subir-manual select#CilindroOD option:selected').val() >= '-225X' && $('div#w3-tabla-graduacion table.datos-subir-manual select#CilindroOD option:selected').val() <= '-800X'){
    grad_cd=1;
  }
  else{
    grad_cd=0;
  }
  if(grad_ed==1 || grad_ei==1 || grad_cd==1 || grad_ci==1){
    tipo_graduacion = "Graduación alta";
    $('.form-micas-grad input[value="Graduación alta"]').click();
    montograduacion = "300";
  }
  else{
    tipo_graduacion = "Graduación baja";
    $('.form-micas-grad input[value="Graduación baja"]').click();
    montograduacion = "0";
  }
  totallente = parseInt(montoarmazon) + parseInt(montopaso1) + parseInt(montopaso2) + parseInt(montograduacion);
  $("div#w3-total-lente").html('<div class="w3-custom"><div class="w3-select"><span class="w3-top-txt">Total</span></div><span class="w3-select-price">$ '+totallente+'</span></div>');
        
        texto_paso3 = "+$ "+parseInt(montograduacion);
        if(parseInt(montograduacion)== 0){
          texto_paso3="Gratis";
        }
        $("div#w3-resumen-compra #w3-resumen-paso3-2").html('<div class="w3-custom"><div class="w3-select"><span>'+tipo_graduacion+'</span></div><span class="w3-select-price">'+texto_paso3+'</span></div>');
});
$("div#w3-tabla-graduacion").on('change', 'table.datos-subir-manual select#CilindroOI', function() {
  if($('.form-micas-grad input[value="Graduación alta"]').prop('checked', true)){
    $('.form-micas-grad input[value="Graduación alta"]').click();
  }
  if($('.form-micas-grad input[value="Graduación baja"]').prop('checked', true)){
    $('.form-micas-grad input[value="Graduación baja"]').click();
  }
  if($('div#w3-tabla-graduacion table.datos-subir-manual select#CilindroOI option:selected').val() >= '-225X' && $('div#w3-tabla-graduacion table.datos-subir-manual select#CilindroOI option:selected').val() <= '-800X'){
    grad_ci=1;
  }
  else{
    grad_ci=0;
  }
  if(grad_ed==1 || grad_ei==1 || grad_cd==1 || grad_ci==1){
    tipo_graduacion = "Graduación alta";
    $('.form-micas-grad input[value="Graduación alta"]').click();
    montograduacion = "300";
  }
  else{
    tipo_graduacion = "Graduación baja";
    $('.form-micas-grad input[value="Graduación baja"]').click();
    montograduacion = "0";
  }
  totallente = parseInt(montoarmazon) + parseInt(montopaso1) + parseInt(montopaso2) + parseInt(montograduacion);
  $("div#w3-total-lente").html('<div class="w3-custom"><div class="w3-select"><span class="w3-top-txt">Total</span></div><span class="w3-select-price">$ '+totallente+'</span></div>');
        
        texto_paso3 = "+$ "+parseInt(montograduacion);
        if(parseInt(montograduacion)== 0){
          texto_paso3="Gratis";
        }
        $("div#w3-resumen-compra #w3-resumen-paso3-2").html('<div class="w3-custom"><div class="w3-select"><span>'+tipo_graduacion+'</span></div><span class="w3-select-price">'+texto_paso3+'</span></div>');
});
/* ****************************************************************  
  //// tabla consulta /******************************
var grad_ed2c = 0; // esfera derecha consulta
var grad_ei2c = 0; // esfera izquierda consulta
var grad_cd2c = 0; // cilindro derecho consulta
var grad_ci2c = 0; // cilindro izquierdo consulta
$("div#w3-tabla-graduacion2").on('change', 'table.datos-subir-manual select#EsferaOD2', function() {
  if($('.form-micas-grad input[value="Graduación alta"]').prop('checked', true)){
    $('.form-micas-grad input[value="Graduación alta"]').click();
  }
  if($('.form-micas-grad input[value="Graduación baja"]').prop('checked', true)){
    $('.form-micas-grad input[value="Graduación baja"]').click();
  }
  if(($('div#w3-tabla-graduacion2 table.datos-subir-manual select#EsferaOD2 option:selected').val() >= '-300' && $('div#w3-tabla-graduacion2 table.datos-subir-manual select#EsferaOD2 option:selected').val() <= '-800') || ($('div#w3-tabla-graduacion2 table.datos-subir-manual select#EsferaOD2 option:selected').val() >= '+300' && $('div#w3-tabla-graduacion2 table.datos-subir-manual select#EsferaOD2 option:selected').val() <= '+800')){ 
    grad_ed2c=1;
  }
  else{
    grad_ed2c=0;
  }
  if(grad_ed2c==1 || grad_ei2c==1 || grad_cd2c==1 || grad_ci2c==1){
    tipo_graduacion = "Graduación alta";
    $('.form-micas-grad input[value="Graduación alta"]').click();
    montograduacion = "500";
  }
  else{
    tipo_graduacion = "Graduación baja";
    $('.form-micas-grad input[value="Graduación baja"]').click();
    montograduacion = "0";
  }
  totallente = parseInt(montoarmazon) + parseInt(montopaso1) + parseInt(montopaso2) + parseInt(montograduacion);
  $("div#w3-total-lente").html('<div class="w3-custom"><div class="w3-select"><span class="w3-top-txt">Total</span></div><span class="w3-select-price">$ '+totallente+'</span></div>');
        
        texto_paso3 = "+$ "+parseInt(montograduacion);
        if(parseInt(montograduacion)== 0){
          texto_paso3="Gratis";
        }
        $("div#w3-resumen-compra #w3-resumen-paso3-2").html('<div class="w3-custom"><div class="w3-select"><span>'+tipo_graduacion+'</span></div><span class="w3-select-price">'+texto_paso3+'</span></div>');
  
});
$("div#w3-tabla-graduacion2").on('change', 'table.datos-subir-manual select#EsferaOI2', function() {
  if($('.form-micas-grad input[value="Graduación alta"]').prop('checked', true)){
    $('.form-micas-grad input[value="Graduación alta"]').click();
  }
  if($('.form-micas-grad input[value="Graduación baja"]').prop('checked', true)){
    $('.form-micas-grad input[value="Graduación baja"]').click();
  }
  if(($('div#w3-tabla-graduacion2 table.datos-subir-manual select#EsferaOI2 option:selected').val() >= '-300' && $('div#w3-tabla-graduacion2 table.datos-subir-manual select#EsferaOI2 option:selected').val() <= '-800') || ($('div#w3-tabla-graduacion2 table.datos-subir-manual select#EsferaOI2 option:selected').val() >= '+300' && $('div#w3-tabla-graduacion2 table.datos-subir-manual select#EsferaOI2 option:selected').val() <= '+800')){
    grad_ei2c=1;
  }
  else{
    grad_ei2c=0;
  }
  if(grad_ed2c==1 || grad_ei2c==1 || grad_cd2c==1 || grad_ci2c==1){
    tipo_graduacion = "Graduación alta";
    $('.form-micas-grad input[value="Graduación alta"]').click();
    montograduacion = "500";
  }
  else{
    tipo_graduacion = "Graduación baja";
    $('.form-micas-grad input[value="Graduación baja"]').click();
    montograduacion = "0";
  }
  totallente = parseInt(montoarmazon) + parseInt(montopaso1) + parseInt(montopaso2) + parseInt(montograduacion);
  $("div#w3-total-lente").html('<div class="w3-custom"><div class="w3-select"><span class="w3-top-txt">Total</span></div><span class="w3-select-price">$ '+totallente+'</span></div>');
        
        texto_paso3 = "+$ "+parseInt(montograduacion);
        if(parseInt(montograduacion)== 0){
          texto_paso3="Gratis";
        }
        $("div#w3-resumen-compra #w3-resumen-paso3-2").html('<div class="w3-custom"><div class="w3-select"><span>'+tipo_graduacion+'</span></div><span class="w3-select-price">'+texto_paso3+'</span></div>');
});
$("div#w3-tabla-graduacion2").on('change', 'table.datos-subir-manual select#CilindroOD2', function() {
  if($('.form-micas-grad input[value="Graduación alta"]').prop('checked', true)){
    $('.form-micas-grad input[value="Graduación alta"]').click();
  }
  if($('.form-micas-grad input[value="Graduación baja"]').prop('checked', true)){
    $('.form-micas-grad input[value="Graduación baja"]').click();
  }
  if($('div#w3-tabla-graduacion2 table.datos-subir-manual select#CilindroOD2 option:selected').val() >= '-300X'){
    grad_cd2c=1;
  }
  else{
    grad_cd2c=0;
  }
  if(grad_ed2c==1 || grad_ei2c==1 || grad_cd2c==1 || grad_ci2c==1){
    tipo_graduacion = "Graduación alta";
    $('.form-micas-grad input[value="Graduación alta"]').click();
    montograduacion = "500";
  }
  else{
    tipo_graduacion = "Graduación baja";
    $('.form-micas-grad input[value="Graduación baja"]').click();
    montograduacion = "0";
  }
  totallente = parseInt(montoarmazon) + parseInt(montopaso1) + parseInt(montopaso2) + parseInt(montograduacion);
  $("div#w3-total-lente").html('<div class="w3-custom"><div class="w3-select"><span class="w3-top-txt">Total</span></div><span class="w3-select-price">$ '+totallente+'</span></div>');
        
        texto_paso3 = "+$ "+parseInt(montograduacion);
        if(parseInt(montograduacion)== 0){
          texto_paso3="Gratis";
        }
        $("div#w3-resumen-compra #w3-resumen-paso3-2").html('<div class="w3-custom"><div class="w3-select"><span>'+tipo_graduacion+'</span></div><span class="w3-select-price">'+texto_paso3+'</span></div>');
});
$("div#w3-tabla-graduacion2").on('change', 'table.datos-subir-manual select#CilindroOI2', function() {
  if($('.form-micas-grad input[value="Graduación alta"]').prop('checked', true)){
    $('.form-micas-grad input[value="Graduación alta"]').click();
  }
  if($('.form-micas-grad input[value="Graduación baja"]').prop('checked', true)){
    $('.form-micas-grad input[value="Graduación baja"]').click();
  }
  if($('div#w3-tabla-graduacion2 table.datos-subir-manual select#CilindroOI2 option:selected').val() >= '-300X'){
    grad_ci2c=1;
  }
  else{
    grad_ci2c=0;
  }
  if(grad_ed2c==1 || grad_ei2c==1 || grad_cd2c==1 || grad_ci2c==1){
    tipo_graduacion = "Graduación alta";
    $('.form-micas-grad input[value="Graduación alta"]').click();
    montograduacion = "500";
  }
  else{
    tipo_graduacion = "Graduación baja";
    $('.form-micas-grad input[value="Graduación baja"]').click();
    montograduacion = "0";
  }
  totallente = parseInt(montoarmazon) + parseInt(montopaso1) + parseInt(montopaso2) + parseInt(montograduacion);
  $("div#w3-total-lente").html('<div class="w3-custom"><div class="w3-select"><span class="w3-top-txt">Total</span></div><span class="w3-select-price">$ '+totallente+'</span></div>');
        
        texto_paso3 = "+$ "+parseInt(montograduacion);
        if(parseInt(montograduacion)== 0){
          texto_paso3="Gratis";
        }
        $("div#w3-resumen-compra #w3-resumen-paso3-2").html('<div class="w3-custom"><div class="w3-select"><span>'+tipo_graduacion+'</span></div><span class="w3-select-price">'+texto_paso3+'</span></div>');
});
************************************************************************* */
//////////////////// PASO 3 INGRESA GRADUACION /////////////////////////////////////////////////////////-----------------------
  $("div#w3-tab-graduacion li #gr-1").click(function(){ //**** enviar mas tarde ******* ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    pasos_graduacion = "Enviar más tarde";
    $("div#w3-resumen-compra #w3-resumen-paso3-2").html('');
    if($("div#w3-tab-graduacion li.gr-1").hasClass('imagepicker-selected')){
      $("div#w3-tab-graduacion li").removeClass('imagepicker-selected');
      $(".line_vdv_micas .sel_vdv_micas").css("width", "66.6%");
      $("div#w3-btn-options-dir div#w3-adv-options").removeClass();
      $("div#w3-btn-options-dir div#w3-adv-options").hide();
      pasos_actual = 3;
      $("div#w3-btn-add-to-cart button.w3-options-add-to-cart").hide();
    }
    else{
      $("div#w3-tab-graduacion li label input").prop( "checked", false );
      $("div#w3-tab-graduacion li.gr-1 label#gr-1 input#btn-gr-1").prop( "checked", true );
      $("div#w3-tab-graduacion li").removeClass('imagepicker-selected');
      $("div#w3-tab-graduacion li.gr-1").addClass('imagepicker-selected');
      $("div#w3-tab-graduacion").removeClass('active').addClass('hide');
      $(".w3-product-options.loaded .product-options-price-info").addClass('config-mica');
      $("div#w3-btn-add-to-cart button.w3-options-add-to-cart").show();
      $(".line_vdv_micas .sel_vdv_micas").css("width", "100%");
      manual = 1;   
      manual2 = 1;
      if(cargar==1){
        $("div#clndrs0yozm2 button.filepond--file-action-button.filepond--action-revert-item-processing").click(); // ***********
        cargar=0;
      }
      $("div#w3-tabla-graduacion").html('');
      $("div#w3-tabla-graduacion2").html('');
      limpiarconsultaw3();
      if(res_mc == 0){
        $(".product-options-price-info .pricing-info-products").after('<div id="w3-resumen-grd"></div>');
        res_mc=1;
      }
      $("div#w3-resumen-grd").html('<div class="grd-info-product">Graduación - '+pasos_graduacion+'</div>');
      if(tipo_pasos=="270"){
        $("div#w3-btn-options-dir").addClass('str');
        $("div#w3-res-270").addClass('config-mica-270');
        $('div#w3-res-270 #w3-resumen-grd-270').html('<div class="grd-info-product">Tipo de mica Monofocal</div><div class="grd-info-product">Graduación - '+pasos_graduacion+'</div>');
      }
      $("div#w3-btn-options-dir div#w3-ret-options").removeClass().addClass('fin');
      $("div#w3-btn-options-dir div#w3-adv-options").removeClass();
      $("div#w3-btn-options-dir div#w3-adv-options").hide();
      pasos_actual = 4;      
      
      if($('.form-micas-grad input[value="Graduación alta"]').prop('checked', true)){
        $('.form-micas-grad input[value="Graduación alta"]').click();
      }
      if($('.form-micas-grad input[value="Graduación baja"]').prop('checked', true)){
        $('.form-micas-grad input[value="Graduación baja"]').click();
      }
      montograduacion = "0";
      totallente = parseInt(montoarmazon) + parseInt(montopaso1) + parseInt(montopaso2) + parseInt(montograduacion);
      $("div#w3-total-lente").html('<div class="w3-custom"><div class="w3-select"><span class="w3-top-txt">Total</span></div><span class="w3-select-price">$ '+totallente+'</span></div>');
        
        $("div#w3-resumen-compra #w3-resumen-paso3-1").html('<div class="w3-custom"><div class="w3-select"><span class="w3-top-txt">'+$('#w3-tab-graduacion .content-encabezado').text()+'</span><span>'+pasos_graduacion+'</span></div></div>');
    }
    return false;
  });
  $("div#w3-btn-options-dir").on("click", "div#w3-adv-options.grd p", function(){ //avanzar a resumen con enviar mas tarde
    $("div#w3-tab-graduacion").removeClass('active').addClass('hide');
    $(".w3-product-options.loaded .product-options-price-info").addClass('config-mica');
    $("div#w3-btn-options-dir div#w3-ret-options").removeClass().addClass('fin');
    $("div#w3-btn-options-dir div#w3-adv-options").removeClass();
    $("div#w3-btn-options-dir div#w3-adv-options").hide();
      if(tipo_pasos=="270"){
        $("div#w3-res-270").addClass('config-mica-270');
      }
  });
  $("div#w3-tab-graduacion li #gr-2").click(function(){ //**** cargar archivo ******* ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    manual = 1;
    manual2 = 1;
    cargar = 1;
    pasos_graduacion = "Cargar archivo";
    $("div#w3-resumen-compra #w3-resumen-paso3-2").html('');
    if($("div#w3-tab-graduacion li.gr-2").hasClass('imagepicker-selected')){
      $("div#w3-tab-graduacion li").removeClass('imagepicker-selected');
      $("div#w3-btn-options-dir div#w3-adv-options").removeClass();
      $("div#w3-btn-options-dir div#w3-adv-options").hide();
      pasos_actual = 3;
      $("div#w3-btn-add-to-cart button.w3-options-add-to-cart").hide();
      $(".line_vdv_micas .sel_vdv_micas").css("width", "66.6%");
    }
    else{
      $("div#w3-tab-graduacion li label input").prop( "checked", false );
      $("div#w3-tab-graduacion li.gr-2 label#gr-2 input#btn-gr-2").prop( "checked", true );
      $("div#w3-tab-graduacion li").removeClass('imagepicker-selected');
      $("div#w3-tab-graduacion li.gr-2").addClass('imagepicker-selected');
      $("div#w3-tab-graduacion").removeClass('active').addClass('hide');
      $("div#w3-tab-graduacion-archivo").removeClass('hide').addClass('active');
      $("div#w3-btn-add-to-cart button.w3-options-add-to-cart").hide();
      $("div#w3-tabla-graduacion").html('');
      $("div#w3-tabla-graduacion2").html('');
      limpiarconsultaw3();
      if(res_mc == 0){
        $(".product-options-price-info .pricing-info-products").after('<div id="w3-resumen-grd"></div>');
        res_mc=1;
      }
      $("div#w3-resumen-grd").html('<div class="grd-info-product">Graduación - '+pasos_graduacion+'</div>');
      if(tipo_pasos=="270"){
        $("div#w3-btn-options-dir").addClass('str');
        $('div#w3-res-270 #w3-resumen-grd-270').html('<div class="grd-info-product">Tipo de mica Monofocal</div><div class="grd-info-product">Graduación - '+pasos_graduacion+'</div>');
      }
      $("div#w3-btn-options-dir div#w3-ret-options").removeClass().addClass('grd-2');
      $("div#w3-btn-options-dir div#w3-adv-options").removeClass().addClass('grd-2');
      $("div#w3-btn-options-dir div#w3-adv-options").show();
      
      if($('.form-micas-grad input[value="Graduación alta"]').prop('checked', true)){
        $('.form-micas-grad input[value="Graduación alta"]').click();
      }
      if($('.form-micas-grad input[value="Graduación baja"]').prop('checked', true)){
        $('.form-micas-grad input[value="Graduación baja"]').click();
      }
      montograduacion = "0";
      totallente = parseInt(montoarmazon) + parseInt(montopaso1) + parseInt(montopaso2) + parseInt(montograduacion);
      $("div#w3-total-lente").html('<div class="w3-custom"><div class="w3-select"><span class="w3-top-txt">Total</span></div><span class="w3-select-price">$ '+totallente+'</span></div>');
        
      $("div#w3-resumen-compra #w3-resumen-paso3-1").html('<div class="w3-custom"><div class="w3-select"><span class="w3-top-txt">'+$('#w3-tab-graduacion .content-encabezado').text()+'</span><span>'+pasos_graduacion+'</span></div></div>');
    }
    
    return false;
  });//**** cargar archivo ******* ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  $("div#w3-btn-options-dir").on("click", "div#w3-ret-options.grd-2 p", function(){ //regresar a graduacion desde archivo
    $("div#w3-tab-graduacion-archivo").removeClass('active').addClass('hide');
    $("div#w3-tab-graduacion").removeClass('hide').addClass('active');
    $("div#w3-btn-options-dir div#w3-ret-options").removeClass().addClass('grd');
    $("div#w3-btn-options-dir div#w3-adv-options").removeClass().addClass('grd2');
      if(tipo_pasos=="270"){
        $("div#w3-btn-options-dir div#w3-ret-options").removeClass();
      }
  });
  $("div#w3-btn-options-dir").on("click", "div#w3-adv-options.grd2 p", function(){ //avanzar a archivo desde graduacion
    $("div#w3-tab-graduacion").removeClass('active').addClass('hide');
    $("div#w3-tab-graduacion-archivo").removeClass('hide').addClass('active');
    $("div#w3-btn-options-dir div#w3-ret-options").removeClass().addClass('grd-2');
    $("div#w3-btn-options-dir div#w3-adv-options").removeClass().addClass('grd-2');
  });
  $("div#w3-btn-options-dir").on("click", "div#w3-adv-options.grd-2 p", function(){ //avanzar a resumen desde archivo
    $("div#w3-tab-graduacion-archivo").removeClass('active').addClass('hide');
    $(".w3-product-options.loaded .product-options-price-info").addClass('config-mica');
      $("div#w3-btn-add-to-cart button.w3-options-add-to-cart").show();
      $(".line_vdv_micas .sel_vdv_micas").css("width", "100%");
    pasos_actual = 4;
    $("div#w3-btn-options-dir div#w3-ret-options").removeClass().addClass('fin-2');
    $("div#w3-btn-options-dir div#w3-adv-options").removeClass();
    $("div#w3-btn-options-dir div#w3-adv-options").hide();
      if(tipo_pasos=="270"){
        $("div#w3-res-270").addClass('config-mica-270');
      }
  });
  
  $("div#w3-tab-graduacion li #gr-3").click(function(){ //**** ingresar manual ******* ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    manual2 = 1;
    pasos_graduacion = "Ingresar Manual";
    $("div#w3-resumen-compra #w3-resumen-paso3-2").html('');
    if($("div#w3-tab-graduacion li.gr-3").hasClass('imagepicker-selected')){
      $("div#w3-tab-graduacion li").removeClass('imagepicker-selected');
      $("div#w3-btn-options-dir div#w3-adv-options").removeClass();
      $("div#w3-btn-options-dir div#w3-adv-options").hide();
      pasos_actual = 3;
      $("div#w3-btn-add-to-cart button.w3-options-add-to-cart").hide();
      $(".line_vdv_micas .sel_vdv_micas").css("width", "66.6%");
      $("div#w3-tabla-graduacion").html('');
      manual=1;
    }
    else{
      grad_ed = 0; // esfera derecha
      grad_ei = 0; // esfera izquierda
      grad_cd = 0; // cilindro derecho
      grad_ci = 0; // cilindro izquierdo
      $("div#w3-tab-graduacion li label input").prop( "checked", false );
      $("div#w3-tab-graduacion li.gr-3 label#gr-3 input#btn-gr-3").prop( "checked", true );
      if(cargar==1){
        $("div#clndrs0yozm2 button.filepond--file-action-button.filepond--action-revert-item-processing").click(); // ***********
        cargar=0;
      }
//      if(manual==1){
    	$("div#w3-tabla-graduacion").html(tablagrd);
      	manual = 0;
//      }
      $("div#w3-tab-graduacion li").removeClass('imagepicker-selected');
      $("div#w3-tab-graduacion li.gr-3").addClass('imagepicker-selected');
      $("div#w3-tab-graduacion").removeClass('active').addClass('hide');
      $("div#w3-tab-graduacion-manual").removeClass('hide').addClass('active');
      $("div#w3-btn-add-to-cart button.w3-options-add-to-cart").hide();
      $("div#w3-tabla-graduacion2").html('');
      limpiarconsultaw3();
      if(res_mc == 0){
        $(".product-options-price-info .pricing-info-products").after('<div id="w3-resumen-grd"></div>');
        res_mc=1;
      }
      if(tipo_pasos=="270"){
        $("div#w3-btn-options-dir").addClass('str');
      }
      $("div#w3-btn-options-dir div#w3-ret-options").removeClass().addClass('grd-3');
      $("div#w3-btn-options-dir div#w3-adv-options").removeClass().addClass('grd-3');
      $("div#w3-btn-options-dir div#w3-adv-options").show();
      
        if(w3_opcion == "Monofocal"){
          $('div#w3-tabla-graduacion tr#row-adicion').hide();
        }
        else{
          $('div#w3-tabla-graduacion tr#row-adicion').show();
        }
      
      if($('.form-micas-grad input[value="Graduación alta"]').prop('checked', true)){
        $('.form-micas-grad input[value="Graduación alta"]').click();
      }
      if($('.form-micas-grad input[value="Graduación baja"]').prop('checked', true)){
        $('.form-micas-grad input[value="Graduación baja"]').click();
      }
      montograduacion = "0";
      totallente = parseInt(montoarmazon) + parseInt(montopaso1) + parseInt(montopaso2) + parseInt(montograduacion);
      $("div#w3-total-lente").html('<div class="w3-custom"><div class="w3-select"><span class="w3-top-txt">Total</span></div><span class="w3-select-price">$ '+totallente+'</span></div>');
        
        $("div#w3-resumen-compra #w3-resumen-paso3-1").html('<div class="w3-custom"><div class="w3-select"><span class="w3-top-txt">'+$('#w3-tab-graduacion .content-encabezado').text()+'</span><span>'+pasos_graduacion+'</span></div></div>');
    }
    return false;
  });//**** ingresar manual ******* ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  $("div#w3-btn-options-dir").on("click", "div#w3-ret-options.grd-3 p", function(){ //regresar a graduacion desde manual
    $("div#w3-tab-graduacion-manual").removeClass('active').addClass('hide');
    $("div#w3-tab-graduacion").removeClass('hide').addClass('active');
    $("div#w3-btn-options-dir div#w3-ret-options").removeClass().addClass('grd');
    $("div#w3-btn-options-dir div#w3-adv-options").removeClass().addClass('grd3');
      if(tipo_pasos=="270"){
        $("div#w3-btn-options-dir div#w3-ret-options").removeClass();
      }
  });
  $("div#w3-btn-options-dir").on("click", "div#w3-adv-options.grd3 p", function(){ //avanzar a manual desde graduacion
    $("div#w3-tab-graduacion").removeClass('active').addClass('hide');
    $("div#w3-tab-graduacion-manual").removeClass('hide').addClass('active');
    $("div#w3-btn-options-dir div#w3-ret-options").removeClass().addClass('grd-3');
    $("div#w3-btn-options-dir div#w3-adv-options").removeClass().addClass('grd-3');
  });
  $("div#w3-btn-options-dir").on("click", "div#w3-adv-options.grd-3 p", function(){ //avanzar a resumen desde manual
    $("div#w3-resumen-grd").html('<div class="grd-info-product">Graduación - '+pasos_graduacion+'</div><div class="grd-info-product">'+tipo_graduacion+'</div>');
    if(tipo_pasos=="270"){
      $("div#w3-res-270").addClass('config-mica-270');
      $('div#w3-res-270 #w3-resumen-grd-270').html('<div class="grd-info-product">Tipo de mica Monofocal</div><div class="grd-info-product">Graduación - '+pasos_graduacion+'</div>');
    }
    $("div#w3-tab-graduacion-manual").removeClass('active').addClass('hide');
    $(".w3-product-options.loaded .product-options-price-info").addClass('config-mica');
      $("div#w3-btn-add-to-cart button.w3-options-add-to-cart").show();
    $(".line_vdv_micas .sel_vdv_micas").css("width", "100%");
    pasos_actual = 4;
    $("div#w3-btn-options-dir div#w3-ret-options").removeClass().addClass('fin-3');
    $("div#w3-btn-options-dir div#w3-adv-options").removeClass();
    $("div#w3-btn-options-dir div#w3-adv-options").hide();
  });
  
  $("div#w3-tab-graduacion li #gr-4").click(function(){ //**** ya soy cliente ****************************************
    $("#w3-ExamenPrecarga").hide();
    manual = 1;
    pasos_graduacion = "Consultado";
    $("div#w3-resumen-compra #w3-resumen-paso3-2").html('');
    if($("div#w3-tab-graduacion li.gr-4").hasClass('imagepicker-selected')){
      $("div#w3-tab-graduacion li").removeClass('imagepicker-selected');
      $("div#w3-btn-options-dir div#w3-adv-options").removeClass();
      $("div#w3-btn-options-dir div#w3-adv-options").hide();
      pasos_actual = 3;
      $("div#w3-btn-add-to-cart button.w3-options-add-to-cart").hide();
      $(".line_vdv_micas .sel_vdv_micas").css("width", "66.6%");
      $("div#w3-tabla-graduacion2").html('');
      manual2=1;
    }
    else{
      $("div#w3-tab-graduacion li label input").prop( "checked", false );
      $("div#w3-tab-graduacion li.gr-4 label#gr-4 input#btn-mi-graduacion-input").prop( "checked", true );
      if(cargar==1){
        $("div#clndrs0yozm2 button.filepond--file-action-button.filepond--action-revert-item-processing").click(); // ***********
        cargar=0;
      }
//      if(manual2==1){
    	$("div#w3-tabla-graduacion2").html(tablagrd2);
      	manual2 = 0;
//      }
      $("div#w3-tab-graduacion li").removeClass('imagepicker-selected');
      $("div#w3-tab-graduacion li.gr-4").addClass('imagepicker-selected');
      $("div#w3-tab-graduacion").removeClass('active').addClass('hide');
      $("div#w3-tab-graduacion-consulta").removeClass('hide').addClass('active');
      $("div#w3-btn-add-to-cart button.w3-options-add-to-cart").hide();
      $("div#w3-tabla-graduacion").html('');
      limpiarconsultaw3();
      if(res_mc == 0){
        $(".product-options-price-info .pricing-info-products").after('<div id="w3-resumen-grd"></div>');
        res_mc=1;
      }
      if(tipo_pasos=="270"){
        $("div#w3-btn-options-dir").addClass('str');
      }
      $("div#w3-btn-options-dir div#w3-ret-options").removeClass().addClass('grd-4');
      $("div#w3-btn-options-dir div#w3-adv-options").removeClass().addClass('grd-4');
      $("div#w3-btn-options-dir div#w3-adv-options").show();
      
      if($('.form-micas-grad input[value="Graduación alta"]').prop('checked', true)){
        $('.form-micas-grad input[value="Graduación alta"]').click();
      }
      if($('.form-micas-grad input[value="Graduación baja"]').prop('checked', true)){
        $('.form-micas-grad input[value="Graduación baja"]').click();
      }
      montograduacion = "0";
      totallente = parseInt(montoarmazon) + parseInt(montopaso1) + parseInt(montopaso2) + parseInt(montograduacion);
      $("div#w3-total-lente").html('<div class="w3-custom"><div class="w3-select"><span class="w3-top-txt">Total</span></div><span class="w3-select-price">$ '+totallente+'</span></div>');
        
        $("div#w3-resumen-compra #w3-resumen-paso3-1").html('<div class="w3-custom"><div class="w3-select"><span class="w3-top-txt">'+$('#w3-tab-graduacion .content-encabezado').text()+'</span><span>'+pasos_graduacion+'</span></div></div>');
    }
    return false;
  });
  $("div#w3-btn-options-dir").on("click", "div#w3-ret-options.grd-4 p", function(){ //regresar a graduacion desde consulta
    $("div#w3-tab-graduacion-consulta").removeClass('active').addClass('hide');
    $("div#w3-tab-graduacion").removeClass('hide').addClass('active');
    $("div#w3-btn-options-dir div#w3-ret-options").removeClass().addClass('grd');
    $("div#w3-btn-options-dir div#w3-adv-options").removeClass().addClass('grd4');
      if(tipo_pasos=="270"){
        $("div#w3-btn-options-dir div#w3-ret-options").removeClass();
      }
  });
  $("div#w3-btn-options-dir").on("click", "div#w3-adv-options.grd4 p", function(){ //avanzar a consulta desde graduacion
    $("div#w3-tab-graduacion").removeClass('active').addClass('hide');
    $("div#w3-tab-graduacion-consulta").removeClass('hide').addClass('active');
    $("div#w3-btn-options-dir div#w3-ret-options").removeClass().addClass('grd-4');
    $("div#w3-btn-options-dir div#w3-adv-options").removeClass().addClass('grd-4');
  });
  $("div#w3-btn-options-dir").on("click", "div#w3-adv-options.grd-4 p", function(){ //avanzar a resumen desde consulta
    if(w3_opcion == "Monofocal" && w3_consulta == true){
      $("div#w3-error-consulta").html('<div>No se puede comprar el tipo de mica "Monofocal" con Adición en la graduación. Favor de seleccionar otro tipo de mica.</div>');
    }
    else{      
      $("div#w3-error-consulta").html('');
      $("div#w3-tab-graduacion-consulta").removeClass('active').addClass('hide');
      $(".w3-product-options.loaded .product-options-price-info").addClass('config-mica');
      $("div#w3-btn-add-to-cart button.w3-options-add-to-cart").show();
      $(".line_vdv_micas .sel_vdv_micas").css("width", "100%");
      //$("div#w3-resumen-grd").html('<div class="grd-info-product">Graduación - '+pasos_graduacion+'</div><div class="grd-info-product">'+tipo_graduacion+'</div>');
      /*if(tipo_pasos=="270"){
        $("div#w3-res-270").addClass('config-mica-270');
        $('div#w3-res-270 #w3-resumen-grd-270').html('<div class="grd-info-product">Tipo de mica Monofocal</div><div class="grd-info-product">Graduación - '+pasos_graduacion+'</div>');
      }*/
      pasos_actual = 4;
      $("div#w3-btn-options-dir div#w3-ret-options").removeClass().addClass('fin-4');
      $("div#w3-btn-options-dir div#w3-adv-options").removeClass();
      $("div#w3-btn-options-dir div#w3-adv-options").hide();
    }
  });
//  $("div#w3-tabla-graduacion2 #btn-consulta-examen-re").click(function(){
  $("div#w3-tabla-graduacion2").on("click", "#btn-consulta-examen-re", function(){
  	$("#w3-ExamenForm").show();
  	$("div#w3-tabla-graduacion2").hide();
    limpiarconsultaw3();
    $("div#w3-resumen-compra #w3-resumen-paso3-2").html('');
  });
  
  $("div#w3-btn-options-dir").on("click", "div#w3-ret-options.grd p", function(){ //regresar a tipo mica
    $("div#w3-tab-graduacion").removeClass('active').addClass('hide');
    $("div.form-micas-fin").show();
    $("div#w3-btn-options-dir div#w3-ret-options").removeClass().addClass('mcsasd');
    $("div#w3-btn-options-dir div#w3-adv-options").removeClass().addClass('mcs');
    $("div#w3-btn-options-dir div#w3-adv-options").show();
  });
  
//////////////////// PASO 4 RESUMEN CONFIGURACION /////////////////////////////////////////////////-----------------------
  $("div#w3-btn-options-dir").on("click", "div#w3-ret-options.fin p", function(){ //regresar a graduacion
    $(".w3-product-options.loaded .product-options-price-info").removeClass('config-mica');
    $("div#w3-tab-graduacion").removeClass('hide').addClass('active');
    $("div#w3-btn-options-dir div#w3-ret-options").removeClass().addClass('grd');
    if(pasos_actual > 3){
      $("div#w3-btn-options-dir div#w3-adv-options").addClass('grd');
      $("div#w3-btn-options-dir div#w3-adv-options").show();
    }
    else{
      $("div#w3-btn-options-dir div#w3-adv-options").removeClass();
      $("div#w3-btn-options-dir div#w3-adv-options").hide();
    }
      if(tipo_pasos=="270"){
        $("div#w3-res-270").removeClass('config-mica-270');
        $("div#w3-btn-options-dir div#w3-ret-options").removeClass();
      }
  });  
  $("div#w3-btn-options-dir").on("click", "div#w3-ret-options.fin-2 p", function(){ //regresar a archivo
    $(".w3-product-options.loaded .product-options-price-info").removeClass('config-mica');
    $("div#w3-tab-graduacion-archivo").removeClass('hide').addClass('active');
    $("div#w3-btn-options-dir div#w3-ret-options").removeClass().addClass('grd-2');
    $("div#w3-btn-options-dir div#w3-adv-options").addClass('grd-2');
    $("div#w3-btn-options-dir div#w3-adv-options").show();
      if(tipo_pasos=="270"){
        $("div#w3-res-270").removeClass('config-mica-270');
      }
  });
  $("div#w3-btn-options-dir").on("click", "div#w3-ret-options.fin-3 p", function(){ //regresar a manual
    $(".w3-product-options.loaded .product-options-price-info").removeClass('config-mica');
    $("div#w3-tab-graduacion-manual").removeClass('hide').addClass('active');
    $("div#w3-btn-options-dir div#w3-ret-options").removeClass().addClass('grd-3');
    $("div#w3-btn-options-dir div#w3-adv-options").addClass('grd-3');
    $("div#w3-btn-options-dir div#w3-adv-options").show();
      if(tipo_pasos=="270"){
        $("div#w3-res-270").removeClass('config-mica-270');
      }
  });
  $("div#w3-btn-options-dir").on("click", "div#w3-ret-options.fin-4 p", function(){ //regresar a consulta
    $(".w3-product-options.loaded .product-options-price-info").removeClass('config-mica');
    $("div#w3-tab-graduacion-consulta").removeClass('hide').addClass('active');
    $("div#w3-btn-options-dir div#w3-ret-options").removeClass().addClass('grd-4');
    $("div#w3-btn-options-dir div#w3-adv-options").addClass('grd-4');
    $("div#w3-btn-options-dir div#w3-adv-options").show();
      if(tipo_pasos=="270"){
        $("div#w3-res-270").removeClass('config-mica-270');
      }
  });
  
  
});

function validargraduacionalta(esfD,esfI,cilD,cilI){
  var esfD2=esfD;
  var esfI2=esfI;
  var cilD2=cilD;
  var cilI2=cilI;
  console.log("datos: "+esfD+" "+esfI+" "+cilD+" "+cilI+" ");
  var montoarmazon=0;  
  var montopaso1 =0;
  var montopaso2 =0; 
  var montograduacion =0;
  var totallente= 0;
  var tipo_grd = "";
  var texto_paso3 = "";
  
  montoarmazon = $("span.product-price__price span.money").text();
  montoarmazon = montoarmazon.replace(/[$.]/g,'');
  montoarmazon = montoarmazon.replace(/,/g, '');
  //montopaso1 = $(".form-micas-inicio .image-picker-item.imagepicker-selected span.precio-paso").text();
  montopaso1 = 0;
  montopaso2 = $(".form-micas-fin .image-picker-item.imagepicker-selected span.precio-paso").text();
  
  //var totalcl = $("div#w3-total-lente span").text();
  if($('.form-micas-grad input[value="Graduación alta"]').prop('checked', true)){
    $('.form-micas-grad input[value="Graduación alta"]').click();
  }
  if($('.form-micas-grad input[value="Graduación baja"]').prop('checked', true)){
    $('.form-micas-grad input[value="Graduación baja"]').click();
  }
  
  //if(($('div#w3-tabla-graduacion2 table.datos-subir-manual select#EsferaOD2 option:selected').val() >= '-300' && $('div#w3-tabla-graduacion2 table.datos-subir-manual select#EsferaOD2 option:selected').val() <= '-800') || ($('div#w3-tabla-graduacion2 table.datos-subir-manual select#EsferaOD2 option:selected').val() >= '+300' && $('div#w3-tabla-graduacion2 table.datos-subir-manual select#EsferaOD2 option:selected').val() <= '+800')){
  if(($('div#w3-tabla-graduacion2 table.datos-subir-manual input#EsferaOD2t').val() >= '-325' && $('div#w3-tabla-graduacion2 table.datos-subir-manual input#EsferaOD2t').val() <= '-800') || ($('div#w3-tabla-graduacion2 table.datos-subir-manual input#EsferaOD2t').val() >= '+325' && $('div#w3-tabla-graduacion2 table.datos-subir-manual input#EsferaOD2t').val() <= '+800')){
    esfD2=1;
  }
  else{
    esfD2=0;
  }
  if(($('div#w3-tabla-graduacion2 table.datos-subir-manual input#EsferaOI2t').val() >= '-325' && $('div#w3-tabla-graduacion2 table.datos-subir-manual input#EsferaOI2t').val() <= '-800') || ($('div#w3-tabla-graduacion2 table.datos-subir-manual input#EsferaOI2t').val() >= '+325' && $('div#w3-tabla-graduacion2 table.datos-subir-manual input#EsferaOI2t').val() <= '+800')){
    esfI2=1;
  }
  else{
    esfI2=0;
  }
  if($('div#w3-tabla-graduacion2 table.datos-subir-manual input#CilindroOD2t').val() >= '-225X' && $('div#w3-tabla-graduacion2 table.datos-subir-manual input#CilindroOD2t').val() <= '-800X'){
    cilD2=1;
  }
  else{
    cilD2=0;
  }
  if($('div#w3-tabla-graduacion2 table.datos-subir-manual input#CilindroOI2t').val() >= '-225X' && $('div#w3-tabla-graduacion2 table.datos-subir-manual input#CilindroOI2t').val() <= '-800X'){
    cilI2=1;
  }
  else{
    cilI2=0;
  }
  if(esfD2==1 || esfI2==1 || cilD2==1 || cilI2==1){
    tipo_grd = "Graduación alta";
    montograduacion = "180";
    $('.form-micas-grad input[value="Graduación alta"]').click();
  }
  else{
    tipo_grd = "Graduación baja";
    montograduacion = "0";
    $('.form-micas-grad input[value="Graduación baja"]').click();
  }
/* ----------------------------------------------------- */
  console.log(" EsferaOD2t:"+esfD2+" EsferaOI2t:"+esfI2+" CilindroOD2t:"+cilD2+" CilindroOI2t:"+cilI2);
  totallente = parseInt(montoarmazon) + parseInt(montopaso1) + parseInt(montopaso2) + parseInt(montograduacion);
console.log("montoarmazon: "+montoarmazon+ " montopaso1: "+montopaso1+ " montopaso2: "+montopaso2+ " montograduacion: "+montograduacion+ " totallente: "+totallente);
  $("div#w3-total-lente").html('<div class="w3-custom"><div class="w3-select"><span class="w3-top-txt">Total</span></div><span class="w3-select-price">$ '+totallente+'</span></div>');
        
  if(parseInt(montograduacion) == 0){
    texto_paso3 = "Gratis";
  }
  else{
    texto_paso3 = "+$ "+parseInt(montograduacion);
  }
  $("div#w3-resumen-compra #w3-resumen-paso3-2").html('<div class="w3-custom"><div class="w3-select"><span>'+tipo_grd+'</span></div><span class="w3-select-price">'+texto_paso3+'</span></div>');
  
/* ----------------------------------------------------- */
//  totalcl = parseInt(totalcl) + parseInt(montograduacion);
// $("div#w3-total-lente").html("Total $ <span>"+totalcl+"</span>");
}
function limpiarconsultaw3(){
  $("#fApellidoPaterno").val('');
  $("#fCelular").val('');
  $('#fFechaNacimiento').val('');
}
  